const backendURL = "https://josiesphones-server.onrender.com"

export const summaryApi = {
    signUp : {
        url: `${backendURL}/api/user/signup`,
        method: "POST",
        data: {
            firstName: String,
            lastName: String,
            email: String,
            password: String,
            profilePic: String,
            role: String
        }
    },

    signIn :{
        url: `${backendURL}/api/user/login`,
        method: "POST",
        data: {
            email: String,
            password: String
        }
    },

    current_user :{
        url: `${backendURL}/api/user/user-details`,
        method: "GET"
    },

    logout: {
        url: `${backendURL}/api/user/logout`,
        method: "GET"
    },

    allUser: {
        url: `${backendURL}/api/user/all-users`,
        method: "GET"
    },

    updateUser: {
        url: `${backendURL}/api/user/update-user`,
        method: "POST",
        data: {
            userId: String,
            firstName: String,
            lastName: String,
            email: String,            
            role: String
        }
    },

    getUserDetailsId: {
        url: `${backendURL}/api/user`,
        method: "GET",
        // data: {
        //     userId: String
        // }
    },

    uploadProduct: {
        url: `${backendURL}/api/product/upload-product`,
        method: "POST"        
    },

    allProducts: {
        url: `${backendURL}/api/product/get-products`,
        method: "GET"
    },

    updateProduct: {
        url: `${backendURL}/api/product/update-product`,
        method: "POST",
        data: {
            productId: String,
            productName: String,
            productPrice: Number,
            productDescription: String,
            productsCategory: String,
            productBrand: String,
            productImage: [],
            productDiscount: Number            
        }
    },

    deleteProduct: {
        url: `${backendURL}/api/product/delete-product`,
        method: "DELETE"
    },

    categoryProduct: {
        url: `${backendURL}/api/product/list-category`,
        method: "GET",
        data: {
            productsCategory: String
        }
    },

    allProductCategories: {
        url: `${backendURL}/api/product/all-categories`,
        method: "POST"
    },

    productDetails: {
        url: `${backendURL}/api/product/product-details`,
        method: "GET",
        data: {            
            productName: String,
            productPrice: Number,
            productDescription: String,
            productsCategory: String,
            productBrand: String,
            productImage: [],
            productDiscount: Number            
        }        
    },

    postReview: {
        url: `${backendURL}/api/review/post-review`,
        method: "POST",
        data: {
            productId: String,
            userId: String,
            rating: Number,
            comment: String
        }
    },

    getReviews: {
        url: `${backendURL}/api/review/get-review`,
        method: "GET",
        data: {
            productId: String
        }
    },

    updateReview: {
        url: `${backendURL}/api/review/update-review`,
        method: "POST",
        data: {
            reviewId: String,
            userId: String,
            rating: Number,
            comment: String
        }
    },

    deleteReview: {
        url: `${backendURL}/api/review/delete-review`,
        method: "DELETE",
        data: {
            reviewId: String,
            userId: String
        }
    },

    addToCart: {
        url: `${backendURL}/api/cart/addtocart`,
        method: "POST",
        data: {
            userId: String,
            productId: String,
            quantity: Number
        }
    },

    cartCounter: {
        url: `${backendURL}/api/cart/countaddtocart`,
        method: "GET",
        
    },

    cartList: {
        url: `${backendURL}/api/cart/cartView`,
        method: "GET",
        data: {
            userId: String
        }
    },

    deleteCart: {
        url: `${backendURL}/api/cart/delete-cart`,
        method: "DELETE",
        data: {
            userId: String,
            productId: String
        }
    },

    updateCart: {
        url: `${backendURL}/api/cart/update-cart`,
        method: "POST",
        data: {
            _id: String,
            quantity: Number
        }
    },

    searchProducts: {
        url: `${backendURL}/api/review/search`,
        method: "GET"        
    },
    
    filterProducts: {
        url: `${backendURL}/api/review/filter`,
        method: "POST",        
    },

    cod: {
        url: `${backendURL}/api/order/cod`,
        method: "POST",
        data: {
            userId: String,
            products: [{
                productId: String,
                quantity: Number
            }]
        }
    },

    stripe: {
        url: `${backendURL}/api/order/stripe`,
        method: "POST",
        data: {
            userId: String,
            products: [{
                productId: String,
                quantity: Number
            }],
            totalPrice: Number
        }
    },

    stripeVerify: {
        url: `${backendURL}/api/order/verifyStripe`,
        method: "POST",        
    },

    flutterwave: {
        url: `${backendURL}/api/order/flw`,
        method: "POST",
        data: {
            userId: String,
            products: [{
                productId: String,
                quantity: Number
            }],
            totalPrice: Number
        }
    },

    flutterwaveVerify: {
        url: `${backendURL}/api/order/verifyFlw`,
        method: "POST",        
    },

    orderHistory: {
        url: `${backendURL}/api/order/userorders`,
        method: "POST",
        data: {
            userId: String
        }
    },

    AdminOrderInventory: {
        url: `${backendURL}/api/order/list`,
        method: "POST"
    },

    OrderStatus: {
        url: `${backendURL}/api/order/status`,
        method: "POST",
        data: {
            orderId: String,
            status: String
        }
    },

    getProfileDetails: {
    url: `${backendURL}/api/profile/get`,
    method: "GET",
},

updateProfileDetails: {
    url: `${backendURL}/api/profile/update`,
    method: "POST",
    data: {
        userId: String,
        profilePic: String,
        address: String,            
        phone: String
    }
},

    newsletterSubcription:{
        url: `${backendURL}/api/newsletter/register`,
        method: "POST",
        data: {
            email: String
        }
    },

    getNewsletterSubcription:{
        url: `${backendURL}/api/newsletter/list`,
        method: "GET",
        data: {
            email: String
        }
    },

    sendNewsletterSubcription:{
        url: `${backendURL}/api/newsletter/send`,
        method: "POST",
        data: {
            email: String,
            status: Boolean
        }
    },

    unSubscribeNewsletter: {
        url: `${backendURL}/api/newsletter/unsubscribe`,
        method: "POST",
        data: {
            email: String
        }
    },

    deleteSubscription:{
        url: `${backendURL}/api/newsletter/delete/:email`,
        method: "DELETE",
        data: {
            email: String
        }
    },

    updateSubscriberStatus: {
        url: `${backendURL}/api/newsletter/status/:email`,
        method: "POST",
        data: {
            email: String,
            isActive: Boolean
        }
    },

    chatMessageAssistant: {
        url: `${backendURL}/api/chat/history/:userId`,
        method: "GET",
        data: {
            userId: String,
            message: String
        }
    },

    openAi: {
        url: `${backendURL}/api/openai/generate-response`,
        method: "POST",
        // data: {
        //     userId: String,
        //     message: String
        // }
    },

    getNotifications: {
  url: `${backendURL}/api/notifications/get-notifications`,
  method: "GET"
},

getUnreadCount: {
  url: `${backendURL}/api/notifications/unread-count`,
  method: "GET"
},

markAsRead: {
  url: `${backendURL}/api/notifications/mark-as-read`,
  method: "POST"
},

markAllAsRead: {
  url: `${backendURL}/api/notifications/mark-all-read`,
  method: "POST"
},

deleteNotification: {
  url: `${backendURL}/api/notifications/delete`,
  method: "DELETE"
},

likeProduct: {
  url: `${backendURL}/api/likes/like-product`,
  method: "POST"
},
toggleLikeProduct: {
  url: `${backendURL}/api/likes/unlike-product`,
  method: "POST"
},
cleanUpLikeProduct: {
  url: `${backendURL}/api/likes/cleanup-orphaned-likes`,
  method: "DELETE"
},

getProductLikesCount: {
  url: `${backendURL}/api/likes/likes-count`,
  method: "GET"
},

isProductLiked: {
  url: `${backendURL}/api/likes/is-liked`,
  method: "GET"
},

getUserLikedProducts: {
  url: `${backendURL}/api/likes/user-liked-products`,
  method: "GET"
},

// ============================================
    // TRADE-IN ROUTES
    // ============================================

    // User Trade-in Routes
    submitTradeIn: {
        url: `${backendURL}/api/tradein/submit`,
        method: "POST",
        data: {
            deviceType: String,
            brand: String,
            model: String,
            condition: String,
            storage: String,
            color: String,
            estimatedValue: Number,
            phoneImages: [String],
            additionalNotes: String
        }
    },

    getMyTradeIns: {
        url: `${backendURL}/api/tradein/my-tradeins`,
        method: "GET"
    },

    updateTradeIn: {
        url: `${backendURL}/api/tradein/update/:tradeInId`,
        method: "PUT",
        data: {
            deviceType: String,
            brand: String,
            model: String,
            condition: String,
            storage: String,
            color: String,
            estimatedValue: Number,
            phoneImages: [String],
            additionalNotes: String
        }
    },

    deleteTradeIn: {
        url: `${backendURL}/api/tradein/delete/:tradeInId`,
        method: "DELETE"
    },

    // Admin Trade-in Routes
    getAllTradeIns: {
        url: `${backendURL}/api/tradein/all`,
        method: "GET"
    },

   reviewTradeIn: {
  url: `${backendURL}/api/tradein/review/:tradeInId`, // Keep the placeholder
  method: "POST",
  data: {
    status: String, // 'approved', 'rejected', 'pending'
    finalValue: Number,
    adminNotes: String
  }
},

    // ============================================
    // REFURBISHED PHONE ROUTES
    // ============================================

    // Public Refurbished Phone Routes
    getRefurbishedPhones: {
        url: `${backendURL}/api/refurbished/get-phones`,
        method: "GET"
    },

    getRefurbishedPhoneDetails: {
    url: `${backendURL}/api/refurbished/details`, // Remove :phoneId from here
    method: "GET"
},

    // Admin Refurbished Phone Routes
    addRefurbishedPhone: {
        url: `${backendURL}/api/refurbished/add`,
        method: "POST",
        data: {
            brand: String,
            model: String,
            storage: String,
            color: String,
            condition: String, // 'excellent', 'good', 'fair'
            price: Number,
            originalPrice: Number,
            images: [String],
            description: String,
            features: [String],
            warranty: String,
            inStock: Boolean,
            stockQuantity: Number
        }
    },

    updateRefurbishedPhone: {
       url: `${backendURL}/api/refurbished/update`,
        method: "PUT",
        data: {
            brand: String,
            model: String,
            storage: String,
            color: String,
            condition: String,
            price: Number,
            originalPrice: Number,
            images: [String],
            description: String,
            features: [String],
            warranty: String,
            inStock: Boolean,
            stockQuantity: Number
        }
    },

    deleteRefurbishedPhone: {
         url: `${backendURL}/api/refurbished/delete`,
        method: "DELETE"
    },

    // ==========================================
// COMPLETE GIFT CARD ROUTES
// ==========================================

// Public Routes
checkGiftCardBalance: {
    url: `${backendURL}/api/giftcard/balance/:code`,
    method: "GET"
},

checkMultipleBalances: {
    url: `${backendURL}/api/giftcard/check-multiple`,
    method: "POST",
    data: {
        codes: [String] // Array of gift card codes
    }
},

// User Routes
purchaseGiftCard: {
    url: `${backendURL}/api/giftcard/purchase`,
    method: "POST",
    data: {
        amount: Number,
        recipientEmail: String,
        recipientName: String,
        message: String,
        design: String,
        paymentMethod: String,
        transactionId: String
    }
},

validateGiftCard: {
    url: `${backendURL}/api/giftcard/validate`,
    method: "POST",
    data: {
        code: String,
        orderAmount: Number
    }
},

applyGiftCard: {
    url: `${backendURL}/api/giftcard/apply`,
    method: "POST",
    data: {
        code: String,
        orderAmount: Number,
        orderId: String
    }
},

getMyGiftCards: {
    url: `${backendURL}/api/giftcard/my-purchases`,
    method: "GET"
},

getReceivedGiftCards: {
    url: `${backendURL}/api/giftcard/received`,
    method: "GET"
},

getGiftCardUsageHistory: {
    url: `${backendURL}/api/giftcard/usage-history/:code`,
    method: "GET"
},

// Admin Routes
getAllGiftCards: {
    url: `${backendURL}/api/giftcard/admin/all`,
    method: "GET",
    // Query params: ?status=active&page=1&limit=20&search=searchterm
},

getGiftCardStats: {
    url: `${backendURL}/api/giftcard/admin/stats`,
    method: "GET"
},

getGiftCardAnalytics: {
    url: `${backendURL}/api/giftcard/admin/analytics`,
    method: "GET",
    // Query params: ?period=30 (days)
},

getGiftCardDetails: {
    url: `${backendURL}/api/giftcard/admin/:id`,
    method: "GET"
},

cancelGiftCard: {
    url: `${backendURL}/api/giftcard/admin/:id/cancel`,
    method: "PUT",
    data: {
        reason: String
    }
},

refundGiftCard: {
    url: `${backendURL}/api/giftcard/admin/:id/refund`,
    method: "POST",
    data: {
        amount: Number,
        reason: String
    }
},

resendGiftCardEmail: {
    url: `${backendURL}/api/giftcard/admin/:id/resend-email`,
    method: "POST"
},

exportGiftCards: {
    url: `${backendURL}/api/giftcard/admin/export/csv`,
    method: "GET",
    // Query params: ?status=active&startDate=2024-01-01&endDate=2024-12-31
},

bulkCancelGiftCards: {
    url: `${backendURL}/api/giftcard/admin/bulk-cancel`,
    method: "POST",
    data: {
        giftCardIds: [String],
        reason: String
    }
},

processGiftCardPayment: {
  url: `${backendURL}/api/giftcard/payment/process`,
  method: 'POST'
},
verifyGiftCardPayment: {
  url: `${backendURL}/api/giftcard/payment/verify`,
  method: 'POST'
},
// DEAL ENDPOINTS
    // Admin Routes
    createDeal: {
        url: `${backendURL}/api/deal/create-deal`,
        method: "POST"
    },
    getAllDeals: {
        url: `${backendURL}/api/deal/all-deals`,
        method: "GET"
    },
    updateDeal: {
        url: `${backendURL}/api/deal/update-deal`, // append /:id when calling
        method: "PUT"
    },
    deleteDeal: {
        url: `${backendURL}/api/deal/delete-deal`, // append /:id when calling
        method: "DELETE"
    },
    toggleDealStatus: {
        url: `${backendURL}/api/deal/toggle-deal-status`, // append /:id when calling
        method: "PATCH"
    },

    // Public Routes
    getActiveDeals: {
        url: `${backendURL}/api/deal/active-deals`,
        method: "GET"
    },
    getDealDetails: {
        url: `${backendURL}/api/deal/deal-details`, // append /:id when calling
        method: "GET"
    },

     // ============================================
    // LOGO MANAGEMENT ROUTES
    // ============================================
    getLogo: {
        url: `${backendURL}/api/logo/get-logo`,
        method: "GET"
    },

    uploadLogo: {
        url: `${backendURL}/api/logo/upload-logo`,
        method: "POST",
        data: {
            imageUrl: String,
            publicId: String,
            format: String,
            bytes: Number
        }
    },

    deleteLogo: {
        url: `${backendURL}/api/logo/delete-logo`,
        method: "DELETE"
    },

    // ============================================
    // BANNER MANAGEMENT ROUTES
    // ============================================
    getBanners: {
        url: `${backendURL}/api/banner/get-banners`,
        method: "GET"
    },

    getAllBanners: {
        url: `${backendURL}/api/banner/admin/all-banners`,
        method: "GET"
    },

    uploadBanner: {
        url: `${backendURL}/api/banner/admin/upload-banner`,
        method: "POST",
        data: {
            desktopImageUrl: String,
            mobileImageUrl: String,
            desktopPublicId: String,
            mobilePublicId: String,
            title: String,
            subtitle: String,
            ctaText: String,
            ctaLink: String,
            isActive: Boolean,
            order: Number
        }
    },

    updateBanner: {
        url: `${backendURL}/api/banner/admin/update-banner`, // append /:id when calling
        method: "PUT",
        data: {
            title: String,
            subtitle: String,
            ctaText: String,
            ctaLink: String,
            isActive: Boolean,
            order: Number
        }
    },

    deleteBanner: {
        url: `${backendURL}/api/banner/admin/delete-banner`, // append /:id when calling
        method: "DELETE"
    },

    reorderBanners: {
        url: `${backendURL}/api/banner/admin/reorder-banners`,
        method: "PUT",
        data: {
            banners: Array // Array of { id, order }
        }
    },

     // Repair Request Endpoints
    createRepairRequest: {
        url: `${backendURL}/api/repair/create`,
        method: "POST"
    },
    getUserRepairRequests: {
        url: `${backendURL}/api/repair/my-requests`,
        method: "GET"
    },
    getRepairRequestById: {
        url: `${backendURL}/api/repair/request/:id`,
        method: "GET"
    },
    getAllRepairRequests: {
        url: `${backendURL}/api/repair/all`,
        method: "GET"
    },
    replyToRepairRequest: {
        url: `${backendURL}/api/repair/reply/:id`,
        method: "POST"
    },
    updateRepairStatus: {
        url: `${backendURL}/api/repair/status/:id`,
        method: "PATCH"
    }

}